module.exports = __webpack_public_path__ + "img/20220317184239.b6e42aaa.png";